import "./style.css";
import data from "@data/la-casa.json";
import PageInSequence from "@page_templates/PageInSequence";

export default class Casa extends PageInSequence {
  static selector = ".casa";

  constructor(block) {
    super(block, data);
  }

  onReady() {}

  onComplete = () => {};

  onResize() {}

  onDestroy() {}
}
